import { apiCall } from '../../services/api';
import { walletSummary } from '../../services/apiVariable';

export const getWalletSummary = (id, page) => new Promise((resolve, reject) => {
  walletSummary.getWalletSummary.entityId = id;
  walletSummary.getWalletSummary.page = page || 1;
  apiCall({ ...walletSummary.getWalletSummary })
    .then((res) => {
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      reject(err);
    });
});
